// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// const OurMission = () => {
//   const [ourMissionPosts, setOurMissionPosts] = useState([]);
//   const [title, setTitle] = useState('');
//   const [description, setDescription] = useState('');

//   useEffect(() => {
//     fetchOurMissionPosts();
//   }, []);

//   const fetchOurMissionPosts = async () => {
//     try {
//       const response = await axios.get('http://127.0.0.1:8000/api/footerservice-getall/');
//       setOurMissionPosts(response.data);

//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const updatePost = async (postId) => {
//     try {
//       await axios.put(`http://127.0.0.1:8000/api/ourmission/${postId}/`, { title, description });
//       fetchOurMissionPosts();
//       setTitle('');
//       setDescription('');
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const deletePost = async (postId) => {
//     try {
//       await axios.delete(`http://127.0.0.1:8000/api/ourmission/${postId}/delete/`);
//       fetchOurMissionPosts();
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleInputChange = (e) => {
//     if (e.target.name === 'title') {
//       setTitle(e.target.value);
//     } else if (e.target.name === 'description') {
//       setDescription(e.target.value);
//     }
//   };

//   return (
//     <div className="flex flex-col items-center justify-center">
//       <h1 className="text-3xl font-bold mb-4">Our Vission</h1>
//       {ourMissionPosts.map((post) => (
//         <div key={post.id} className="flex flex-col items-start mb-4">
//           <h2 className="text-xl font-bold">{post.title}</h2>
//           <p>{post.description}</p>
//           <div className="flex mt-2">
//             <input
//               type="text"
//               name="title"
//               value={title}
//               onChange={handleInputChange}
//               placeholder="New Title"
//               className="border border-gray-300 rounded px-2 py-1 mr-2"
//             />
//             <input
//               type="text"
//               name="description"
//               value={description}
//               onChange={handleInputChange}
//               placeholder="New Description"
//               className="border border-gray-300 rounded px-2 py-1 mr-2"
//             />
//             <button
//               onClick={() => updatePost(post.id)}
//               className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded"
//             >
//               Update
//             </button>
//             <button
//               onClick={() => deletePost(post.id)}
//               className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded ml-2"
//             >
//               Delete
//             </button>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default OurMission;



import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LoadingLogo from './LoadingLogo';

const OurMission = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true); // New loading state
  const [showFullDescription, setShowFullDescription] = useState({});
  const toggleDescription = (postId) => {
    setShowFullDescription((prevState) => ({
      ...prevState,
      [postId]: !prevState[postId],
    }));
  }
  // const isLoggedIn = localStorage.getItem('token') && localStorage.getItem('user');
  const isLoggedIn = !!(localStorage.getItem('token') && localStorage.getItem('user'));
  
  useEffect(() => {
    fetchBlogPosts();
  }, []);

  const fetchBlogPosts = () => {
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'multipart/form-data',
    };
  
    if (token) {
      headers.Authorization = `token ${token}`;
    }
  
    axios
      .get('http://127.0.0.1:8000/api/footerservice-getall/', { headers })
      .then((response) => {
        setBlogPosts(response.data);
        console.log(response.data)
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching blog posts:', error);
        setLoading(false);
      });
  };


return (
  <div className="outer-card shadow-lg rounded-lg bg-gray-200 mx-auto w-11/12 mt-4">
  <h1 className='flex flex-row justify-center items-center font-semibold p-3 py-10 text-4xl mt-20 text-center'>Some of Our Products</h1>
  {loading ? ( // Render the loading spinner if loading is true
  <div> 
 
  <LoadingLogo />
  <h1 className='flex flex-row justify-center items-center text-center text-synergy-blue animate-pulse font-bold'>
  Please Wait Fetching Products From the Database
</h1>
  </div>
      // <LoadingLogo />
    ) : (
  <>
  <div className="flex flex-wrap justify-center ">
    {blogPosts.map((post) => (
      <div key={post.id} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 p-4">
        <div className="bg-white rounded-lg shadow-lg">
          <img src={post.image} alt={post.name} className="h-48 w-full rounded-t-lg " />
          <div className="p-4">

          <div className='overflow-y-auto bg w-full' style={{ maxHeight: '60px' }}>
            <p className="text-lg font-semibold">{post.title}</p>
          </div>
          <div className='overflow-y-auto bg w-full p-1' style={{ maxHeight: showFullDescription[post.id] ? 'none' : '70px' }}>
          <h3 className="mt-2 text-gray-600">{post.description}</h3>
        </div>
        <button
        onClick={() => toggleDescription(post.id)}
        className="mt-2 bg-blue-500 text-sm px-2 py-1 rounded-lg mr-2 text-white hover:cursor-pointer hover:bg-blue-600 p-1"
      >
        {showFullDescription[post.id] ? 'Show Less' : 'Show More'}
      </button>

          </div>
        </div>
      </div>
    ))}

  </div>
  </>
  )}
  </div>
);
};

export default OurMission;